import { Component } from '@angular/core';
import { IModalDialog } from 'ngx-modal-dialog';
import { FormGroup } from '@angular/forms';
import { UserService } from '../../shared/services/user.service';
import { PreLoginService } from '../../shared/services/pre-login.service';

/**
 * Modal to display the email change form.
 */
@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss']
})
export class ChangeEmailComponent implements IModalDialog {
  /** Array where each element defines a field's icon and inputs */
  // For example:
  // fields = [
  //   password: {
  //     icon: 'fa-lock',
  //     inputs: [ {id: 'password', label: 'Password', type: 'password', validators: [Validators.required] } ],
  //     isPassword: true
  //   }
  // ]
  fields;

  constructor(
    private userService: UserService,
    private preloginService: PreLoginService
  ) {}

  /**
   * Called after initialization.
   */
  dialogInit() {
    const formFields = this.preloginService.getFormFields();
    this.fields = [formFields.password, formFields.email];
  }

  /**
   * Handles form submission.
   *
   * @param form References submitted form
   */
  onSubmit(form: FormGroup) {
    this.userService.changeEmail(form.value.password, form.value.email);
  }
}
